import { ArrowUp } from "lucide-react"
import { AnimatePresence, motion } from "motion/react"
import { useEffect, useState } from "react"

export function ScrollToTopButton() {
	const [isVisible, setIsVisible] = useState(false)

	useEffect(() => {
		const toggleVisibility = () => {
			if (window.scrollY > 400) {
				setIsVisible(true)
			} else {
				setIsVisible(false)
			}
		}

		window.addEventListener("scroll", toggleVisibility)
		return () => window.removeEventListener("scroll", toggleVisibility)
	}, [])

	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		})
	}

	return (
		<AnimatePresence>
			{isVisible && (
				<motion.button
					animate={{ opacity: 1, scale: 1 }}
					aria-label="Scroll to top"
					className="fixed right-4 bottom-4 z-[var(--z-sticky)] flex size-10 cursor-pointer items-center justify-center rounded-full border border-border-highlight bg-bg-card shadow-lg transition-colors hover:bg-bg-tertiary focus:outline-none focus:ring-2 focus:ring-breakout-brand sm:right-8 sm:bottom-8 sm:size-12"
					exit={{ opacity: 0, scale: 0.9 }}
					initial={{ opacity: 0, scale: 0.9 }}
					onClick={scrollToTop}
					title="Scroll to top"
					type="button"
					whileHover={{ y: -2 }}
					whileTap={{ scale: 0.95 }}
				>
					<ArrowUp aria-hidden="true" className="size-5 text-text-primary sm:size-6" />
				</motion.button>
			)}
		</AnimatePresence>
	)
}
